import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { AddNumberCard } from 'pages/settings/pages/numbers/ui/AddNumberCard/AddNumberCard'
import { NumbersPath } from 'pages/settings/pages/numbers/route/numbersPath'
import styles from './styles.module.scss'

export const AddNumber = observer(() => {
  const entities = useEntitiesContext()
  const { uk_compliance } = entities.featureFlagsStore

  const ADD_NUMBER_INFO = [
    {
      icon: 'shoppingCart' as const,
      path: `/${NumbersPath.buyNumber.stepsRoot}`,
      title: 'Buy a number',
      subtitle: uk_compliance
        ? 'Get a local, toll-free or international number'
        : 'Get a local or toll-free number',
    },
    {
      icon: 'plug' as const,
      path: `/${NumbersPath.addNumberFromApp.stepsRoot}`,
      title: 'Add a number from an app',
      subtitle: 'Connect a number from a calling app (Aircall, RingCentral, etc.)',
    },
    {
      icon: 'phone' as const,
      path: `/${NumbersPath.textEnableLandline.stepsRoot}`,
      title: 'Text-enable a landline',
      subtitle: 'Send and receive text messages with your landline',
    },
    {
      icon: 'arrowRight' as const,
      title: 'Port your number',
      subtitle: 'Move your number to Salesmsg for both texting and calling',
      id: 'dropdownItem_portNumbers',
    },
  ]

  return (
    <div className={styles.content}>
      {ADD_NUMBER_INFO.map((item, index) => (
        <AddNumberCard
          customId={item.id}
          key={index}
          icon={item.icon}
          title={item.title}
          subtitle={item.subtitle}
          path={item.path}
        />
      ))}
    </div>
  )
})
